import { useState, useEffect, useRef } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faPlus,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";
import { useSettings } from "../../context/SettingsContext";

function ServiceInvoices() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    payment_type: "",
    license_type_id: "",
    paid: "",
    customer_id: "",
    services: [
      {
        service_id: "",
        cost: "",
        car_number: "",
        car_type: "",
        car_model: "",
        payer: "",
        value: "",
      },
    ],
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [filters, setFilters] = useState({
    from: "",
    to: "",
    invoice_number: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [nextInvoice, setNextInvoice] = useState();
  const [licences, setLicences] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const { settings } = useSettings();

  useEffect(() => {
    API.get("/get-all-customers")
      .then((res) => setCustomers(res.data.data || []))
      .catch(() => toast.error("فشل تحميل العملاء"));

    API.get("/services")
      .then((res) => setServicesList(res.data.data || []))
      .catch(() => toast.error("فشل تحميل الخدمات"));

    API.get("/next-invoice-number")
      .then((res) => setNextInvoice(res.data.next_invoice_number || null))
      .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));

    API.get("/licenseTypes")
      .then((res) => setLicences(res.data.data || null))
      .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));

    const params = new URLSearchParams(window.location.search);
    const invoiceUuid = params.get("invoice");

    if (invoiceUuid) {
      // استدعاء بيانات الفاتورة من الـ API وفتح المودال مباشرة
      API.get(`/invoices/${invoiceUuid}`)
        .then((res) => {
          setSelectedInvoice(res.data.data);
          setShowDetailsModal(true);
          // ممكن تفتح الطباعة بعد ما المودال يظهر
          setTimeout(() => window.print(), 1500);
        })
        .catch(() => toast.error("فشل تحميل بيانات الفاتورة"));
    }
  }, []);

  const handleSearch = () => {
    // if (!filters.from || !filters.to) {
    //     toast.error("من فضلك اختر الفترة (من – إلى)");
    //     return;
    // }

    //     let result = allInvoices;
    //     if (filters.invoice_number) {
    //     result = result.filter((inv) =>
    //         inv.invoice_number?.toString().includes(filters.invoice_number)
    //     );
    // }
    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };

  const total = formData.services.reduce(
    (sum, s) => sum + Number(s.value || 0),
    0
  );
  const costTotal = formData.services.reduce(
    (sum, s) => sum + Number(s.cost || 0),
    0
  );
  const remaining = total - Number(formData.paid || 0);

  const handleAdd = () => {
    setFormData({
      date: new Date().toISOString().split("T")[0],
      payment_type: "",
      paid: "",
      customer_id: "",
      license_type_id: "",
      services: [
        {
          service_id: "",

          cost: "",
          car_number: "",
          car_type: "",
          car_model: "",
          value: "",
          payer: "",
        },
      ],
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
    // console.log(nextInvoice);
  };

  const handleEdit = (record) => {
    setFormData({ ...record });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
    // console.log(formData);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/invoices/${deleteId}`);
      console.log("تم حذف الفاتورة بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleServiceChange = (index, field, value) => {
    const updated = [...formData.services];
    updated[index][field] = value;
    setFormData({ ...formData, services: updated });
  };

  const addService = () => {
    setFormData({
      ...formData,
      services: [
        ...formData.services,
        {
          service_id: "",
          cost: "",
          car_number: "",
          car_type: "",
          car_model: "",
          payer: "",
          value: "",
        },
      ],
    });
  };

  const removeService = (index) => {
    const updated = formData.services.filter((_, i) => i !== index);
    setFormData({ ...formData, services: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {
      if (editId) {
        await API.put(`/invoices/${editId}`, formData);
        console.log("تم تعديل الفاتورة بنجاح");
      } else {
        await API.post("/invoices", formData);
        console.log("تم إضافة الفاتورة بنجاح");
      }
      setShowModal(false);
      API.get("/next-invoice-number")
        .then((res) => setNextInvoice(res.data.next_invoice_number || null))
        .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        console.log("حدث خطأ أثناء الحفظ");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleShowDetails = (invoice) => {
    setSelectedInvoice(invoice);
    setShowDetailsModal(true);
    // console.log(invoice);
  };
  const columns = [
    { header: "رقم الفاتورة", accessor: "invoice_number" },
    { header: "التاريخ", accessor: "date" },
    { header: "العميل", accessor: "customer.name" },
    {
      header: "التكلفة",
      accessor: (row) =>
        row.services?.reduce((sum, s) => sum + Number(s.cost || 0), 0),
    },
    {
      header: "الاجمالى",
      accessor: (row) => Math.trunc(row.services[0]?.value),
    },
    {
      header: "طريقة الدفع",
      accessor: (row) =>
        row.payment_type
          ? row.payment_type === "cash"
            ? "كاش"
            : row.payment_type === "credit"
            ? "آجل"
            : row.payment_type === "bank_transfer"
            ? "تحويل بنكي"
            : row.payment_type === "card"
            ? "شبكة"
            : ""
          : "",
    },
    {
      header: "إجراءات",
      accessor: (row) => (
        <>
          <Can permission="invoice_show">
            <button
              className="btn btn-sm mx-1 extrabtn"
              onClick={() => handleShowDetails(row)}
              title="عرض التفاصيل">
              <FontAwesomeIcon icon={faEye} color="white" />
            </button>
          </Can>
          <Can permission="invoice_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>
          <Can permission="invoice_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true,
    },
  ];

  const taxPercent = parseFloat(settings?.tax_percent || 0);
  const taxValue = (total * taxPercent) / 100;
  const totalAfterTax = total + taxValue;
  const profit = formData.services.reduce(
    (sum, s) => sum + (Number(s.value || 0) - Number(s.cost || 0)),
    0
  );
  const profitAfterTax = formData.services.reduce(
    (sum, s) => sum + (Number(totalAfterTax || 0) - Number(s.cost || 0)),
    0
  );
  // console.log(totalAfterTax);

  useEffect(() => {
    if (showDetailsModal && selectedInvoice?.uuid) {
      const qrContainer = document.getElementById("invoice-qrcode");
      if (qrContainer) {
        qrContainer.innerHTML = ""; // تنظيف أي QR سابق

        // const url = `${window.location.origin}/?invoice=${selectedInvoice.uuid}`;
        // const url = `http://localhost:3000/invoice/${selectedInvoice.uuid}`;
        const url = `https://api.motogates.com/invoice/${selectedInvoice.uuid}`;
        // console.log(selectedInvoice.uuid);

        if (window.QRCode) {
          new window.QRCode(qrContainer, {
            text: url,
            width: 128,
            height: 128,
          });
        }
      }
    }
  }, [showDetailsModal, selectedInvoice]);
  return (
    <div className="container mt-5">
      <Mytitle title="فواتير الخدمات" />

      {/* <Can permission="invoice_create">

                <MyButton
                    text="إضافة فاتورة"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={`${editId ? "تعديل فاتورة" : "إضافة فاتورة"} (${
          formData.invoice_number ? formData.invoice_number : nextInvoice
        })`}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form"
        className="invoices-modal">
        <div className="form-grid">
          {/* <div className="form-group">
                        <MyInput
                            label="رقم الفاتورة"
                            value={formData.invoice_number}
                            onChange={(e) => setFormData({ ...formData, invoice_number: e.target.value })}
                            error={errors.invoice_number?.[0]}
                            disabled={!!editId}
                        />
                    </div> */}

          <div className="form-group">
            <MyInput
              label="التاريخ"
              type="date"
              value={formData.date}
              onChange={(e) =>
                setFormData({ ...formData, date: e.target.value })
              }
              error={errors.date?.[0]}
            />
          </div>

          <div className="form-group">
            <MyInput
              as="select"
              value={formData.payment_type}
              onChange={(e) =>
                setFormData({ ...formData, payment_type: e.target.value })
              }
              error={errors.payment_type?.[0]}
              options={[
                { value: "", label: "اختر طريقة الدفع" },
                { value: "cash", label: "كاش" },
                { value: "credit", label: "آجل" },
                { value: "bank_transfer", label: "تحويل بنكي" },
                { value: "card", label: "شبكة" },
              ]}
              disabled={editId}
            />
          </div>

          {/* {!editId  && ( */}
          <div className="form-group">
            <MyInput
              as="select"
              // label="العميل"
              value={formData.customer_id}
              onChange={(e) =>
                setFormData({ ...formData, customer_id: e.target.value })
              }
              error={errors.customer_id?.[0]}
              options={[
                { value: "", label: "اختر العميل" },
                ...customers.map((c) => ({ value: c.id, label: c.name })),
              ]}
              disabled={editId}
            />
          </div>
          {/* )} */}

          {/* {!editId  && ( */}
          {settings?.licence_type === 1 && (
            <div className="form-group">
              <MyInput
                as="select"
                // label="العميل"
                value={formData.license_type_id}
                onChange={(e) =>
                  setFormData({ ...formData, license_type_id: e.target.value })
                }
                error={errors.customer_id?.[0]}
                options={[
                  { value: "", label: "التراخيص" },
                  ...licences.map((c) => ({ value: c.id, label: c.name })),
                ]}
                disabled={editId}
              />
            </div>
          )}
          {/* )} */}
        </div>

        <div className="scroll-invoice-table">
          {!(formData.payment_type !== "cash" && editId) && (
            <button
              type="button"
              className="add-service-btn"
              onClick={addService}>
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}

          <table className="services-table add-service">
            <thead>
              <tr>
                <th style={{ width: "250px" }}>الخدمة</th>
                <th style={{ width: "120px" }}>التكلفة</th>
                <th style={{ width: "120px" }}>السعر</th>
                {settings?.bool_1 == 1 && <th>{settings?.string_1 || ""}</th>}
                {settings?.bool_2 == 1 && <th>{settings?.string_2 || ""}</th>}
                {settings?.bool_3 == 1 && <th>{settings?.string_3 || ""}</th>}
                {settings?.bool_4 == 1 && <th>{settings?.string_4 || ""}</th>}
                {/* <th>{settings?.string_2 || "النوع"}</th>
                <th>{settings?.string_3 || "الموديل"}</th>
                <th>{settings?.string_4 || "إسم ٱلْمُخَلِّصُ"}</th> */}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {formData.services.map((srv, index) => (
                <tr key={index}>
                  <td>
                    <select
                      value={srv.service_id}
                      onChange={(e) =>
                        handleServiceChange(index, "service_id", e.target.value)
                      }
                      disabled={formData.payment_type !== "cash" && editId}>
                      <option value="">اختر الخدمة</option>
                      {servicesList.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      type="number"
                      value={srv.cost}
                      onChange={(e) =>
                        handleServiceChange(index, "cost", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={srv.value}
                      onChange={(e) =>
                        handleServiceChange(index, "value", e.target.value)
                      }
                      // disabled={editId && !!formData.customer_id}
                      disabled={formData.payment_type !== "cash" && editId}
                    />
                  </td>
                  {settings?.bool_1 == 1 && (
                    <td>
                      <input
                        value={srv.string_1}
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "car_number",
                            e.target.value
                          )
                        }
                        // disabled={editId && !!formData.customer_id}
                        disabled={formData.payment_type !== "cash" && editId}
                      />
                    </td>
                  )}
                  {settings?.bool_2 == 1 && (
                    <td>
                      <input
                        value={srv.string_2}
                        onChange={(e) =>
                          handleServiceChange(index, "car_type", e.target.value)
                        }
                        // disabled={editId && !!formData.customer_id}
                        disabled={formData.payment_type !== "cash" && editId}
                      />
                    </td>
                  )}
                  {settings?.bool_3 == 1 && (
                    <td>
                      <input
                        value={srv.string_3}
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "car_model",
                            e.target.value
                          )
                        }
                        // disabled={editId && !!formData.customer_id}
                        // disabled={formData.payment_type !== "cash" && editId}
                      />
                    </td>
                  )}
                  {settings?.bool_4 == 1 && (
                    <td>
                      <input
                        value={srv.string_4}
                        onChange={(e) =>
                          handleServiceChange(index, "payer", e.target.value)
                        }
                        // disabled={editId && !!formData.customer_id}
                        disabled={formData.payment_type !== "cash" && editId}
                      />
                    </td>
                  )}
                  <td>
                    {!(formData.payment_type !== "cash" && editId) && (
                      <button
                        type="button"
                        className="delete-service-btn"
                        onClick={() => removeService(index)}>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="invoice-footer">
          {settings?.tax_percent != "0.00" && (
            <>
              {" "}
              <MyInput
                label={` الربح بعد الضريبة`}
                value={profitAfterTax.toFixed(2)}
                disabled
              />
              <MyInput
                label="الإجمالي بعد الضريبة"
                value={totalAfterTax.toFixed(2)}
                disabled
              />
              <MyInput
                label={`قيمة الضريبة (${settings?.tax_percent || 0}%)`}
                value={taxValue.toFixed(2)}
                disabled
              />
            </>
          )}
          {formData.payment_type !== "cash" && (
            <>
              <MyInput label="المتبقي" value={remaining} disabled />
              <MyInput
                label="المدفوع"
                type="number"
                value={formData.paid}
                onChange={(e) =>
                  setFormData({ ...formData, paid: e.target.value })
                }
                error={errors.paid?.[0]}
              />
            </>
          )}
          {/* 👇 أضف السطرين دول */}
          <MyInput label="الإجمالي" value={total} disabled />
          <MyInput label="الربح" value={profit} disabled />
        </div>
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذه الفاتورة؟
      </ModalForm>
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title={`فاتورة  خدمات`}
        className="invoice"
        mode="print"
        modal="invoice">
        {selectedInvoice ? (
          <>
            {/* ===== بيانات العميل ===== */}
            <div className="invoice-details bg-white text-dark p-2" dir="rtl">
              <div className="row mb-1">
                <div className="col-6">
                  <p className="mb-2">
                    العميل: {selectedInvoice.customer?.name}
                  </p>
                </div>
                <div className="col-6">
                  <p className="mb-2">
                    نوع الدفع:{" "}
                    {selectedInvoice.payment_type === "cash"
                      ? "نقدي"
                      : "تحويل بنكي"}
                  </p>
                </div>
                <div className="col-6">
                  <p className="mb-2">
                    إجمالي الفاتورة: {selectedInvoice.total}
                  </p>
                </div>

                {settings?.licence_type == 1 && (
                  <div className="col-6">
                    <p className="mb-2">
                      الترخيص: {selectedInvoice?.license_type?.name || "-----"}
                    </p>
                  </div>
                )}
                <div className="col-6">
                  <p className="mb-2">
                    رقم الفاتورة: {selectedInvoice.invoice_number}
                  </p>
                </div>
                <div className="col-6">
                  <p className="mb-2">التاريخ: {selectedInvoice.date}</p>
                </div>

                {settings?.tax_percent != "0.00" && (
                  <>
                    <div className="col-6">
                      {" "}
                      <p className="mb-2">
                        نسبة الضريبة: {`${settings?.tax_percent} % ` || "-----"}
                      </p>
                    </div>
                    <div className="col-6">
                      <p className="mb-2">
                        الإجمالى بعد الضريبة:{" "}
                        {`${selectedInvoice?.total_after_tax} ` || "-----"}
                      </p>
                    </div>{" "}
                    <div className="col-6">
                      <p className="mb-2">
                        قيمة الضريبة:{" "}
                        {`${selectedInvoice?.tax_value} ` || "-----"}
                      </p>
                    </div>
                  </>
                )}
                <div className="col-6">
                  <p className="mb-2">
                    حالة الدفع:{" "}
                    <span
                      className={
                        Number(selectedInvoice.remaining) > 0
                          ? "text-danger"
                          : "text-success"
                      }>
                      {Number(selectedInvoice.remaining) > 0
                        ? "متبقي"
                        : "مدفوعة"}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* ===== جدول الخدمات ===== */}
            <div className="mt-3" dir="rtl">
              <h5 className="fw-bold mb-3 text-center">الخدمات</h5>
              <table className="table table-bordered text-center align-middle invoices">
                <thead className="table-light">
                  <tr>
                    <th>م</th>
                    <th>اسم الخدمة</th>
                    <th>القيمة</th>
                    {settings?.bool_1 == 1 && <th>{settings?.string_1}</th>}
                    {settings?.bool_2 == 1 && <th>{settings?.string_2}</th>}
                    {settings?.bool_3 == 1 && <th>{settings?.string_3}</th>}
                    {settings?.bool_4 == 1 && <th>{settings?.string_4}</th>}
                    {/* <th> النوع</th>
                    <th> الموديل</th> */}
                  </tr>
                </thead>
                <tbody>
                  {selectedInvoice.services?.map((srv, index) => (
                    <tr key={srv.id}>
                      <td>{index + 1}</td>
                      <td>{srv.service?.name || "-"}</td>
                      <td>{srv?.value}</td>
                      {/* <td>{srv?.car_number}</td>
                      <td>{srv?.car_type}</td>
                      <td>{srv?.car_model}</td> */}
                      {srv?.car_number && <td>{srv?.car_number}</td>}
                      {srv?.car_type && <td>{srv?.car_type}</td>}
                      {srv?.car_model && <td>{srv?.car_model}</td>}
                      {srv?.payer && <td>{srv?.payer}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="text-center h-100 d-flex flex-column justify-content-start pt-5">
              <div
                id="invoice-qrcode"
                className="d-flex justify-content-center"></div>
              <p className="mt-2 small text-muted">
                امسح الكود لعرض الفاتورة عبر الرابط المباشر
              </p>
            </div>
          </>
        ) : (
          // <table className="table table-bordered">
          //   <thead>
          //     <tr>
          //       <th>التاريخ</th>
          //       <th>الموظف</th>
          //       <th>رقم الهاتف</th>
          //       <th>النوع</th>
          //       <th>القيمة</th>
          //       <th>الوصف</th>
          //     </tr>
          //   </thead>
          //   <tbody>
          //     <tr>
          //       <td>{selectedInvoice.date}</td>
          //       <td>{selectedInvoice.employee?.name}</td>
          //       <td>{selectedInvoice.employee?.phone}</td>
          //       <td>
          //         {selectedInvoice.cash_type === "cash"
          //           ? "نقدي"
          //           : selectedInvoice.cash_type === "bank"
          //           ? "تحويل بنكي"
          //           : "-"}
          //       </td>
          //       <td>{selectedInvoice.value}</td>
          //       <td>{selectedInvoice.description || "-"}</td>
          //     </tr>
          //   </tbody>
          // </table>
          <p>لا توجد بيانات متاحة.</p>
        )}
      </ModalForm>
      <div className="row flex-row-reverse mb-3">
        {/* دى الطريقة القديمة بالفلتر بالتاريخ وزرار البحث */}
        {/* <div className="col-md-2">
                    <MyInput
                        label="من"
                        type="date"
                        value={filters.from}
                        onChange={(e) =>
                            setFilters({ ...filters, from: e.target.value })
                        }
                        dontShowDay={true}
                    />
                </div>

                <div className="col-md-2">
                    <MyInput
                        label="إلى"
                        type="date"
                        value={filters.to}
                        onChange={(e) =>
                            setFilters({ ...filters, to: e.target.value })
                        }
                        dontShowDay={true}
                    />
                </div> */}

        {/* <div className="col-md-2">
                    <MyInput
                        label="رقم الفاتورة"
                        type="search"
                        value={filters.invoice_number}
                        onChange={(e) =>
                            setFilters({ ...filters, invoice_number: e.target.value })
                        }
                        dontShowDay={true}
                    />
                </div>


                <div className="col-md-1 d-flex align-items-center">
                    <MyButton onClick={handleSearch} text="بحث" />
                </div> */}
      </div>

      <MyTable
        resource="invoices-from-to"
        method="post"
        title={"فواتير الخدمات"}
        body={appliedFilters}
        invoice={true}
        columns={columns}
        refreshKey={refreshKey}
        // invoiceNumber={filters.invoice_number}
        dateFilter={{ field: "created_at", label: "تاريخ الإنشاء" }}
        filters={[
          { type: "text", name: "invoice_number", label: "بحث برقم الفاتورة" },
          // { type: "text", name: "customer.name", label: "بحث باسم العميل" },
          {
            type: "select",
            name: "payment_type",
            label: "طريقة الدفع",
            options: [
              { value: "", label: "الكل" },
              { value: "cash", label: "نقدي" },
              { value: "credit", label: "آجل" },
              { value: "bank_transfer", label: "تحويل بنكى" },
              { value: "card", label: "بطاقة" },
            ],
          },
        ]}
        button={{
          text: "إضافة فاتورة",
          onClick: handleAdd,
          variant: "success",
          permission: "invoice_create",
        }}
      />
    </div>
  );
}

export default ServiceInvoices;
